module.exports = __webpack_public_path__ + "static/cta-2-moc-11-5a388fd13db8d36cc56022cbe92a0b31.png";